module.exports = __webpack_public_path__ + "static/media/billing.e6285146.svg";